import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { getImageUrl } from '@/utils/getImageUrl'

export default /*#__PURE__*/_defineComponent({
  name: 'ConsultingView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "wrapper",
    style: _normalizeStyle({'background-image': `url(${_unref(getImageUrl)('landing/consulting.png')})`})
  }, null, 4))
}
}

})